<template>
  <el-dialog
    title="承兑汇率"
    :visible="visible"
    width="720px"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <ele-pro-table
      ref="table"
      :datasource="list"
      :columns="columns"
      :loading="loading"
      :need-page="false"
      :toolkit="[]"
      height="420"
      tool-class="ele-toolbar-actions">
      <template slot="toolbar">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-refresh"
          class="ele-btn-icon"
          :loading="loading"
          @click="loadList">
          刷新
        </el-button>
      </template>
      <template slot="rate" slot-scope="{ row }">
        <el-input-number
          v-model="row.rate"
          :min="0"
          :precision="6"
          :step="0.01"
          :controls="false"
          class="ele-fluid ele-text-left"
          placeholder="汇率" />
      </template>
    </ele-pro-table>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="saving" :disabled="!list.length" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AcceptorRateDialog',
  props: {
    visible: Boolean
  },
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      columns: [
        { prop: 'id', label: '序号', width: 80, align: 'center' },
        { prop: 'bot_group_name', label: '群组名称', minWidth: 160, align: 'center', showOverflowTooltip: true },
        { prop: 'bot_group_id', label: '群组ID', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { prop: 'rate', label: '汇率', minWidth: 160, align: 'center', slot: 'rate' }
      ]
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.list = [];
        return;
      }
      this.loadList();
    }
  },
  methods: {
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    loadList() {
      this.loading = true;
      this.$http
        .get('/acceptor/rateList')
        .then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            const rows = res.data.data || [];
            this.list = rows.map((row) => ({
              id: row.id,
              bot_group_name: row.bot_group_name,
              bot_group_id: row.bot_group_id,
              rate: row.rate === null || row.rate === undefined || row.rate === ''
                ? 0
                : Number(row.rate)
            }));
            return;
          }
          this.$message.error(res.data.msg || '获取承兑失败');
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    save() {
      if (!this.list.length) return;
      for (let i = 0; i < this.list.length; i++) {
        const row = this.list[i];
        const rate = Number(row.rate);
        if (Number.isNaN(rate) || rate < 0) {
          this.$message.error('汇率无效');
          return;
        }
      }
      this.saving = true;
      this.$http
        .post('/acceptor/batchRate', {
          items: this.list.map((row) => ({
            id: row.id,
            rate: Number(row.rate)
          }))
        })
        .then((res) => {
          this.saving = false;
          if (res.data.code === 0) {
            this.updateVisible(false);
            return;
          }
          this.$message.error(res.data.msg || '保存失败');
        })
        .catch((e) => {
          this.saving = false;
          this.$message.error(e.message);
        });
    }
  }
};
</script>
